import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            漫迷热评
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            来自真实用户的阅读体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200 rounded-xl p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.user}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.user}</div>
                  <div className="text-xs text-foreground-400">
                    在《{comment.manga}》下的评论 · {comment.time}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}